import "@/styles/globals";
import type { AppProps } from "next/app";
import { GlobalStyled } from "@/styles/globals";
import { Provider } from "react-redux";
import { persistor, store } from "@/redux/store";
import vfWebView from "@vodafonetr/vf-webview-ts";
import { useEffect } from "react";
import { PersistGate } from "redux-persist/integration/react";

function MyApp({ Component, pageProps }: AppProps) {
  useEffect(() => {
    if (vfWebView) {
      //Library imported
    }
  }, []);

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <GlobalStyled />
        <Component {...pageProps} />
      </PersistGate>
    </Provider>
  );
}

export default MyApp;
